export default __webpack_public_path__ + "static/media/PS.f35f0e92.svg";